// extracted by mini-css-extract-plugin
module.exports = {"country":"Europe-module--country--fW-UH"};